import React from 'react'
import styled from 'styled-components'
import { InnerLayout } from '../styles/Layouts'
import Title from '../Components/Title'
import SmallTitle from './SmallTitle'
import { BusinessCenterOutlined } from '@material-ui/icons'
import { SchoolOutlined } from '@material-ui/icons'
import ResumeItem from './ResumeItem'

function Resume() {
    const briefcase = <BusinessCenterOutlined />
    const school = <SchoolOutlined />

    return (
        <ResumeStyled>
            <Title title={'Resume'} span={'resume'} />
            <InnerLayout>
                <div className="small-title">
                    <SmallTitle icon={briefcase} title={'Working Experince'} />
                </div>
                <div className="resume-content">
                    <ResumeItem
                        year={'03/2022 – 04/2022'}
                        title={'Web Developer Intern '}
                        subTitle={'Learnovate ecommerce'}
                        text={'Worked on various projects and developed a variety of web sites using various web technologies such as Bootstrap 5, HTML 5, CSS 3, and JavaScript.'}
                    />
                    <ResumeItem
                        year={'02/2022 – 03/2022'}
                        title={'Full Stack Web Development Intern'}
                        subTitle={'Nyx Wolves'}
                        text={'Made a meaningful contribution to NYX Wolves webpage using React.js and used passport.js, Node.js, and Express.js to implement Google and Facebook Login/Register.'}
                    />
                    <ResumeItem
                        year={'09/2021 – 10/2021'}
                        title={'Full Stack Web Development Intern'}
                        subTitle={'TechSnap'}
                        text={'Developed and deployed a Chat website using React.js, HTML, CSS and Firebase, which has a Login/Register using Gmail-Id functionality, people can chat with each other in different groups in this website.'}
                    />
                    <ResumeItem
                        year={'08/2021 – 09/2021'}
                        title={'Web Development Intern'}
                        subTitle={'The Sparks Foundation'}
                        text={'Donation website created using React.js, HTML, CSS with a payment gateway integrated into the website using Razor pay which made it a fully functional website for donation, Banking Stimulation website created using Node.js, Express, Mongo DB, Ejs, HTML, CSS and Bootstrap and deployed on Heroku, website is small scale stimulation of banking system.'}
                    />
                    <ResumeItem
                        year={'06/2020 – 07/2020'}
                        title={'Fundraising Intern'}
                        subTitle={'Youth Empowerment Foundation'}
                        text={'Raised funds through online fundraising campaigns for covid-19 relief, received an LOR after completion of the internship.'}
                    />
                </div>
                <div className="small-title  u-small-title-margin">
                <SmallTitle icon={school} title={'Education'} />
                </div>
                <div className="resume-content">
                    <ResumeItem
                        year={'2019 - 2023'}
                        title={'SRM Institute of Science and Technology'}
                        subTitle={'Bachelors in Technology - CSE Chennai, India'}
                    />
                    <ResumeItem
                        year={'2018 - 2019'}
                        title={'Sterling Public School'}
                        subTitle={'Higher Secondary School Varanasi, India'}
                    />
                    <ResumeItem
                        year={'2016 - 2017'}
                        title={'KVN Public School'}
                        subTitle={'Secondary School Varanasi, India'}
                    />  
                </div>
            </InnerLayout>
        </ResumeStyled>

    )
}

const ResumeStyled = styled.section`
   .small-title{
       padding-bottom: 3rem;
   }
   .u-small-title-margin{
       margin-top:4rem;
   }
   .resume-content{
       border-left:2px solid var(--border-color);
   }
`;

export default Resume
